import { createTheme, adaptV4Theme } from '@mui/material/styles';

export const cusTheme = createTheme(
	adaptV4Theme({
		palette: {
			primary: {
				main: '#8E9DF2'
			},
			secondary: {
				main: '#8797AF'
			}
		}
	})
);
